import { classNames } from '../../../utils/style-class.utils';
export var menu = 'w-full';
export var icon = 'h-6 w-6 pr-2';
export var iconClear = 'h-6 w-6 mr-2';
export var menuItems = 'rounded-md bg-white shadow-card';
export var menuItem = 'flex flex-row py-2 px-2 cursor-pointer h-12';
export var menuItemWrapper = 'py-1';
export var enter = 'transition ease-out duration-100';
export var enterFrom = 'transform opacity-0 scale-95';
export var enterTo = 'transform opacity-100 scale-100';
export var leave = 'transition ease-in duration-75';
export var leaveFrom = 'transform opacity-100 scale-100';
export var leaveTo = 'transform opacity-0 scale-95';
export var label = 'font-medium block text-base font-body text-textDark';
export var overlay = function (overlayTopOffset) {
    return "absolute top-".concat(overlayTopOffset || '177', " z-20 inset-0 bg-gray-500 bg-opacity-75");
};
export var infoWrapper = 'px-4 py-3 border-b border-uiBg';
export var getButtonStyles = function (colour, open, hasSelectedItems, touched) {
    var baseStyles = 'mt-1 flex flex-row items-center truncate justify-between origin-top-right right-0 rounded-md border-2 pl-4 pr-1 leading-5 py-2 active:bg-secondary';
    if (!touched && !hasSelectedItems) {
        return classNames(baseStyles, 'border-uiBg', 'bg-white');
    }
    if (open) {
        return classNames(baseStyles, 'bg-white', "border-".concat(colour), 'text-white');
    }
    if (hasSelectedItems) {
        return classNames(baseStyles, "border-uiBg", "border-".concat(colour), "bg-".concat(colour));
    }
    return classNames(baseStyles, 'border-secondary', 'bg-white');
};
export var getDropDownIcon = function (colour, isSelected) {
    var baseStyle = "h-6 w-6 ml-1 mr-2";
    var styles = classNames(baseStyle, "text-".concat(isSelected ? colour : 'uiLight'));
    return styles;
};
export var getButtonIcon = function (colour, open, hasSelectedItems) {
    var baseStyle = "h-6 w-6 ml-1 mr-2";
    if (hasSelectedItems && !open) {
        return classNames(baseStyle, "text-white");
    }
    return classNames(baseStyle, "text-".concat(colour));
};
//# sourceMappingURL=search-dropdown.styles.js.map